import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "./assets/css/styles.css"
import "./assets/css/bootstrap.min.css"
import "animate.css/animate.css";
const app = createApp(App)

app.use(router) // 🚀 habilitar router
app.mount("#app")
